import * as $ from 'jquery';

export default class StickyHeader {
  static NAMESPACE = 'axel-sticky-header';

  public opts;
  public label;
  private renderer;

  constructor(renderer, opts = {}) {
    this.opts = opts;
    this.renderer = renderer;
    this.label = 'sticky-header';
  }

  static namespace = (evtName) => evtName + '.' + StickyHeader.NAMESPACE;

  initialize(renderer, containerEl) {
    return renderer;
  }

  buildTable(tableEl, containerEl, opts: any = {}) {
    const ns = StickyHeader.namespace;
    const $headerContainer = $('<div/>', { class: 'js-table-header-container header-container' });
    const theadEl = tableEl.querySelector('thead');
    const theadParentEl = theadEl.parentElement;
    const $table = tableEl instanceof HTMLTableElement ? $(tableEl) : $(tableEl.querySelector('.js-main-table'));
    const updateHeaderPosition = () => {
      $headerContainer.css('top', containerEl.scrollTop);
    };

    if (tableEl instanceof HTMLTableElement) {
      // create container and move table element to it
    } else {
      $(tableEl).append($headerContainer.append($('<table/>', { class: 'js-header-table' }).append(theadEl)));
    }
    theadParentEl.insertBefore($(theadEl).clone().get(0), theadParentEl.firstChild);

    $(containerEl).on(ns('scroll'), updateHeaderPosition);

    // set initial position
    updateHeaderPosition();

    // add plugin class
    $(tableEl).addClass(StickyHeader.NAMESPACE);

    return tableEl;
  }
}
